import { useAuth0 } from "@auth0/auth0-react";
import { Box } from "@mui/system";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import {
  Wrapper,
  UserIdentitify,
  InformationList,
  Messages,
} from "src/components";
import { ContentContainer, PageHeader } from "src/components/Layouts/AppShell";
import { getSettingsData } from "src/helpers/helperSettings";
import { isHomeLeaseSwitcherEnabled } from "src/helpers/helperLease";
import { useGetUserQuery } from "src/store/services/privateApi";
import { safeLogout } from "src/shared/utilities/fullStorySession";

export const SettingsScreenContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { logout } = useAuth0();
  const { tpRentReportingFeature, tpHomeLeaseSwitcher } = useFlags();
  const leaseSwitcherOn = isHomeLeaseSwitcherEnabled(tpHomeLeaseSwitcher);

  const [errorMessage, setErrorMessage] = useState<string>("");

  const { data, isSuccess, isLoading } = useGetUserQuery(null);

  // check is credit reporting is enabled or not, using creditConsumerId ___
  const isCreditReportingReady =
    isSuccess && data && data?.user?.isCreditReportingReady;

  const clickAction = (type: any) => {
    switch (type) {
      case "LogOut":
        safeLogout(logout, {
          logoutParams: { returnTo: window.location.origin },
        });
        break;
      case "AccountInformation":
        navigate("/settings/account-info");
        break;
      case "Leases":
        navigate("/settings/leases");
        break;
      case "RentReporting":
        navigate("/rent/reporting/home");
        break;
      case "Languages":
        navigate("/settings/languages");
        break;
      case "Help":
        // @ts-ignore
        window["ZohoHCAsap"]?.Action?.("open");
        break;
      case "Question":
        navigate("/settings/question");
        break;
      case "Docs":
        navigate("/settings/docs");
        break;
      case "Applications":
        navigate("/settings/applications");
        break;
    }
  };
  let settingsObj = getSettingsData(t, isSuccess && data && !data.user, {
    isCreditReportingReady: isCreditReportingReady,
    isDisabledTheCreditReportingFeature: !tpRentReportingFeature,
  });
  if (!leaseSwitcherOn) {
    settingsObj = settingsObj.filter(
      (item: { id?: string }) => item.id !== "Leases"
    );
  }

  return (
    <Wrapper isAuthorizedWrapper>
      <ContentContainer size="narrow">
        <PageHeader title={t("settings.HeaderTitle")} />
        <UserIdentitify
          isLoading={isLoading}
          isSuccess={isSuccess}
          data={data}
        />
        <Box>
          <InformationList onClick={clickAction} data={settingsObj} />
        </Box>
        {errorMessage !== "" && (
          <Messages
            messageHeading={"Identity Verification"}
            messageContent={errorMessage}
            closeEvent={() => setErrorMessage("")}
            bottomMargin={4}
            topMargin={4}
          />
        )}
      </ContentContainer>
    </Wrapper>
  );
};
